import './PeriscopeLink.scss';
import { AMPLITUDE_EVENT } from '@sonar-software/sonar-analytics';
import { getSonarObjectTypeSourceLabel } from '@sonar-software/sonar-ts-lib';
import { NewWindowIcon } from './NewWindowIcon';
import { useAmplitude } from '@hooks';
import React, { useCallback } from 'react';
function getTitle(sonarObjectType) {
    return `View in ${getSonarObjectTypeSourceLabel(sonarObjectType)}`;
}
export const PeriscopeLink = ({ iconColor, id, sonarObjectType, url }) => {
    const logAnalyticEvent = useAmplitude();
    const handleClick = useCallback((e) => {
        e.stopPropagation();
        logAnalyticEvent({
            data: { objectType: sonarObjectType },
            id: AMPLITUDE_EVENT.SALESFORCE_URL_CLICKED
        });
    }, [logAnalyticEvent, sonarObjectType]);
    if (!url) {
        return null;
    }
    const title = getTitle(sonarObjectType);
    return (React.createElement("div", { className: 'periscope-link' },
        React.createElement("a", { href: url, id: id, onClick: handleClick, target: '_blank', title: title },
            React.createElement(NewWindowIcon, { color: iconColor, title: title }))));
};
